import { get, put, deleteRequest } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useGetTripMediaList = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        let qs = [];
        if (data.searchFilter !== undefined && data.searchFilter !== null) qs.push(`searchFilter=${data.searchFilter}`);
        if (data.contentType !== undefined && data.contentType !== null) qs.push(`contentType=${data.contentType}`);
        if (data.isApproved !== undefined && data.isApproved !== null) qs.push(`isApproved=${data.isApproved}`);
        if (data.cityID !== undefined && data.cityID !== null) qs.push(`cityID=${data.cityID}`);

        const queryString = qs.length > 0 ? `?${qs.join('&')}` : '';
        return await get(`tripmedia/list${queryString}`);
    }, options);
};

export const useApproveTripMedia = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: { tripMediaID: string, isApproved: boolean }) => {
        return await put(`tripmedia/approve?tripMediaID=${data.tripMediaID}&isApproved=${data.isApproved}`, {});
    }, options);
};

export const useDeleteTripMedia = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (tripMediaID: string) => {
        return await deleteRequest(`tripmedia/delete/${tripMediaID}`);
    }, options);
};
